import { ReactElement } from "react";

import { useAuditLogContext } from "@ryde/redux";
import { IAuditLogNormalized } from "@ryde/shared";

import { Collapse } from "../collapse";
import { EntityHeader } from "./entity-header";
import { EntityPropertiesWithControls } from "./entity-properties-with-controls";

interface IEntityItemProps {
  entityItemData: IAuditLogNormalized;
  isCollapsed?: boolean;
  onToggleCollapsed?: () => void;
}

export const EntityItem = ({
  entityItemData,
  isCollapsed,
  onToggleCollapsed,
}: IEntityItemProps): ReactElement => {
  const { searchValue, showSearchResultsOnly } = useAuditLogContext();

  return (
    <Collapse
      forceCollapsed={!!searchValue && !showSearchResultsOnly}
      isCollapsed={showSearchResultsOnly ? false : isCollapsed}
      onToggleCollapsed={onToggleCollapsed}
      CollapseHeader={<EntityHeader entityItemData={entityItemData} />}
    >
      <EntityPropertiesWithControls
        entity={entityItemData.entity}
        data={entityItemData.entityProperties}
      />
    </Collapse>
  );
};
